(() => {
  const cartAddUrl = () => window.theme?.routes?.cart_add_url || '/cart/add.js';

  const initProductPage = (root) => {
    if (!root || root.dataset.obpReady === 'true') return;
    root.dataset.obpReady = 'true';

    const preorder = root.dataset.obpPreorder === 'true';
    const preorderPreview = root.dataset.obpPreviewMode === 'true';

    const mainImage = root.querySelector('[data-obp-main-image]');
    const thumbnails = Array.from(root.querySelectorAll('[data-obp-thumb]'));
    const offers = Array.from(root.querySelectorAll('[data-obp-offer]'));
    const variantInput = root.querySelector('[data-obp-variant]');
    const currentPrice = root.querySelector('[data-obp-current-price]');
    const currentOriginal = root.querySelector('[data-obp-current-original]');
    const buyButton = root.querySelector('[data-obp-buy-button]');
    const mobilePrice = root.querySelector('[data-obp-mobile-price]');
    const mobileOffer = root.querySelector('[data-obp-mobile-offer]');
    const desktopBuybar = root.querySelector('[data-obp-desktop-buybar]');
    const desktopPrice = root.querySelector('[data-obp-desktop-price]');
    const desktopOffer = root.querySelector('[data-obp-desktop-offer]');
    const desktopBuyButton = root.querySelector('[data-obp-desktop-buy]');
    const buyErrorWrapper = root.querySelector('.product-form__error-message-wrapper');
    const buyError = buyErrorWrapper?.querySelector('.product-form__error-message');
    const preorderPreviewHint = root.querySelector('[data-obp-preorder-preview-hint]');
    const stationOffers = Array.from(root.querySelectorAll('[data-obp-station-capable]'));
    const stationSelector = root.querySelector('[data-obp-station-selector]');
    const stationCount = root.querySelector('[data-obp-station-count]');
    const stationMinus = root.querySelector('[data-obp-station-minus]');
    const stationPlus = root.querySelector('[data-obp-station-plus]');
    const includedStation = root.querySelector('[data-obp-included-station]');
    const includedStationText = root.querySelector('[data-obp-included-station-text]');
    const includedProtector = root.querySelector('[data-obp-included-protector]');
    let stationQuantity = 1;
    let paypalSyncTimer;

    const syncPayPalAmount = (formattedPrice) => {
      const normalizedPrice = String(formattedPrice || '')
        .replace(/[^0-9,.-]/g, '')
        .replace(/\./g, '')
        .replace(',', '.');
      const amount = Number.parseFloat(normalizedPrice);
      if (!Number.isFinite(amount)) return;

      document.querySelectorAll('[data-pp-message][data-pp-placement="product"]').forEach((message) => {
        if (Number(message.getAttribute('data-pp-amount')) !== amount) {
          message.setAttribute('data-pp-amount', amount.toFixed(2));
        }
      });
    };

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        thumbnails.forEach((item) => item.classList.remove('is-active'));
        thumbnail.classList.add('is-active');
        if (!mainImage) return;

        mainImage.style.opacity = '0';
        window.setTimeout(() => {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = thumbnail.dataset.image;
          mainImage.alt = thumbnail.dataset.alt || '';
          mainImage.style.opacity = '1';
        }, 150);
      });
    });

    const getStationValue = (offer, prefix, quantity) => offer?.getAttribute(`data-${prefix}-${quantity}`) || '';

    const updateStationOffers = (nextQuantity) => {
      if (!stationOffers.length) return;
      stationQuantity = Math.min(5, Math.max(1, Number(nextQuantity) || 1));
      const euroValue = (value) => Number(String(value || '').replace(/[^0-9,.-]/g, '').replace('.', '').replace(',', '.')) || 0;

      if (stationCount) stationCount.textContent = String(stationQuantity);
      if (stationMinus) stationMinus.disabled = stationQuantity <= 1;
      if (stationPlus) stationPlus.disabled = stationQuantity >= 5;
      if (includedStationText) {
        includedStationText.textContent = `${stationQuantity} Original-${stationQuantity === 1 ? 'Ladestation' : 'Ladestationen'}`;
      }

      let selectedStationOffer = null;
      stationOffers.forEach((offer) => {
        const offerKind = offer.dataset.offerKind || 'station';
        const price = getStationValue(offer, 'price', stationQuantity) || offer.dataset.price;
        const original = getStationValue(offer, 'original', stationQuantity);
        const saving = Math.max(0, euroValue(original) - euroValue(price));
        const stationCopy = offer.querySelector('[data-obp-station-offer-copy]');
        const stationOriginal = offer.querySelector('[data-obp-station-original]');
        const stationPrice = offer.querySelector('[data-obp-station-price]');
        const stationSaving = offer.querySelector('[data-obp-station-saving]');

        offer.dataset.price = price;
        offer.dataset.original = original;
        if (offerKind === 'complete') {
          offer.dataset.short = stationQuantity === 1
            ? 'All-in-Set'
            : `All-in-Set mit ${stationQuantity} Ladestationen`;
          if (stationCopy) {
            stationCopy.textContent = `Gerät + Familien-App + Originalkabel + ${stationQuantity} ${stationQuantity === 1 ? 'Ladestation' : 'Ladestationen'} + Displayschutzfolie im 2er-Set. Jede weitere Ladestation 29,90 €.`;
          }
        } else {
          offer.dataset.short = stationQuantity === 1
            ? 'Set mit Ladestation'
            : `Set mit ${stationQuantity} Ladestationen`;
          if (stationCopy) {
            stationCopy.textContent = `Gerät + Familien-App + Originalkabel + ${stationQuantity} ${stationQuantity === 1 ? 'Ladestation' : 'Ladestationen'}. Jede weitere Ladestation 29,90 €.`;
          }
        }
        if (stationOriginal) stationOriginal.textContent = original;
        if (stationPrice) stationPrice.textContent = price;
        if (stationSaving) stationSaving.textContent = `${saving.toLocaleString('de-DE', { minimumFractionDigits: saving % 1 ? 2 : 0, maximumFractionDigits: 2 })} € sparen`;
        if (offer.classList.contains('is-selected')) selectedStationOffer = offer;
      });

      if (selectedStationOffer) selectOffer(selectedStationOffer);
    };

    const selectOffer = (offer) => {
      if (preorderPreviewHint) preorderPreviewHint.hidden = true;
      offers.forEach((item) => {
        const selected = item === offer;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
      });

      const isStationSet = stationOffers.includes(offer);
      const offerKind = offer.dataset.offerKind || 'base';
      if (stationSelector) stationSelector.hidden = !isStationSet;
      if (includedStation) includedStation.hidden = !isStationSet;
      if (includedProtector) includedProtector.hidden = offerKind !== 'complete';
      if (includedStationText) {
        includedStationText.textContent = `${stationQuantity} Original-${stationQuantity === 1 ? 'Ladestation' : 'Ladestationen'}`;
      }
      if (variantInput) variantInput.value = offer.dataset.variantId;
      if (currentPrice) currentPrice.textContent = offer.dataset.price;
      if (currentOriginal) currentOriginal.textContent = offer.dataset.original || '';
      syncPayPalAmount(offer.dataset.price);
      window.clearTimeout(paypalSyncTimer);
      paypalSyncTimer = window.setTimeout(() => syncPayPalAmount(offer.dataset.price), 800);
      if (mobilePrice) mobilePrice.textContent = offer.dataset.price;
      if (mobileOffer) {
        mobileOffer.textContent = preorder
          ? `${offer.dataset.short} · nächste Lieferung`
          : `${offer.dataset.short} · einmalig`;
      }

      const extraAvailable = !isStationSet || stationQuantity === 1 || offer.dataset.extraAvailable === 'true';
      const available = (preorder || offer.dataset.available === 'true') && extraAvailable;
      if (buyButton) {
        buyButton.disabled = !available;
        buyButton.textContent = available
          ? (preorder
            ? 'Jetzt 30 € sparen & bestellen'
            : `Jetzt in den Warenkorb – ${offer.dataset.price}`)
          : 'Derzeit nicht verfügbar';
      }
      if (desktopPrice) desktopPrice.textContent = offer.dataset.price;
      if (desktopOffer) desktopOffer.textContent = offer.dataset.short;
      if (desktopBuyButton) {
        desktopBuyButton.disabled = !available;
        desktopBuyButton.textContent = available
          ? (preorder ? 'Jetzt 30 € sparen & bestellen' : 'In den Warenkorb')
          : 'Derzeit nicht verfügbar';
        desktopBuyButton.setAttribute(
          'aria-label',
          available
            ? (preorder
              ? `${offer.dataset.short} mit 30 Euro Preisvorteil bestellen`
              : `${offer.dataset.short} für ${offer.dataset.price} in den Warenkorb legen`)
            : `${offer.dataset.short} ist derzeit nicht verfügbar`
        );
      }
    };

    offers.forEach((offer) => {
      offer.addEventListener('click', () => selectOffer(offer));
    });

    stationMinus?.addEventListener('click', () => updateStationOffers(stationQuantity - 1));
    stationPlus?.addEventListener('click', () => updateStationOffers(stationQuantity + 1));

    const queryQuantity = Number(new URLSearchParams(window.location.search).get('ladeplaetze'));
    updateStationOffers(queryQuantity >= 1 && queryQuantity <= 5 ? queryQuantity : 1);

    const selectedOffer = offers.find((offer) => offer.classList.contains('is-selected')) || offers[0];
    if (selectedOffer) selectOffer(selectedOffer);

    desktopBuyButton?.addEventListener('click', () => {
      if (desktopBuyButton.disabled || desktopBuyButton.classList.contains('loading')) return;
      buyButton?.click();
    });

    if (buyButton && desktopBuyButton) {
      const syncDesktopLoadingState = () => {
        const loading = buyButton.classList.contains('loading');
        desktopBuyButton.classList.toggle('loading', loading);
        if (loading) {
          desktopBuyButton.setAttribute('aria-busy', 'true');
        } else {
          desktopBuyButton.removeAttribute('aria-busy');
        }
      };
      const buyButtonObserver = new MutationObserver(syncDesktopLoadingState);
      buyButtonObserver.observe(buyButton, {
        attributes: true,
        attributeFilter: ['class', 'aria-busy']
      });
    }

    if (desktopBuybar && buyButton) {
      const desktopViewport = window.matchMedia('(min-width: 901px)');
      let buyButtonAboveViewport = buyButton.getBoundingClientRect().bottom < 0;

      const updateDesktopBuybar = () => {
        const visible = desktopViewport.matches && buyButtonAboveViewport;
        desktopBuybar.classList.toggle('is-visible', visible);
        desktopBuybar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (visible) {
          desktopBuybar.removeAttribute('inert');
        } else {
          desktopBuybar.setAttribute('inert', '');
        }
      };

      if ('IntersectionObserver' in window) {
        const buyButtonVisibilityObserver = new IntersectionObserver(([entry]) => {
          buyButtonAboveViewport = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          updateDesktopBuybar();
        }, { threshold: 0 });
        buyButtonVisibilityObserver.observe(buyButton);
      } else {
        window.addEventListener('scroll', () => {
          buyButtonAboveViewport = buyButton.getBoundingClientRect().bottom < 0;
          updateDesktopBuybar();
        }, { passive: true });
      }

      desktopViewport.addEventListener?.('change', updateDesktopBuybar);
      updateDesktopBuybar();
    }

    buyButton?.addEventListener('click', async () => {
      if (buyButton.disabled || buyButton.classList.contains('loading')) return;
      if (preorderPreview) {
        if (preorderPreviewHint) preorderPreviewHint.hidden = false;
        return;
      }
      const selected = offers.find((offer) => offer.classList.contains('is-selected'));
      const variantId = Number(selected?.dataset.variantId || variantInput?.value);
      if (!variantId) return;

      const preorderProperties = preorder
        ? { Lieferhinweis: 'Vorbestellung · Versand voraussichtlich 16.–21. September 2026' }
        : null;
      const items = [{
        id: variantId,
        quantity: 1,
        ...(preorderProperties ? { properties: preorderProperties } : {})
      }];
      if (stationOffers.includes(selected) && stationQuantity > 1) {
        const extraVariantId = Number(selected.dataset.extraStationVariantId);
        if (!extraVariantId) return;
        items.push({
          id: extraVariantId,
          quantity: stationQuantity - 1,
          ...(preorderProperties ? { properties: preorderProperties } : {})
        });
      }

      buyButton.classList.add('loading');
      buyButton.setAttribute('aria-busy', 'true');
      if (buyErrorWrapper) buyErrorWrapper.hidden = true;

      try {
        const response = await fetch(cartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });
        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || 'Das Produkt konnte nicht hinzugefügt werden.');
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: { product: result.items?.[0] || result }
        }));
        window.setTimeout(() => document.getElementById('Cart-Drawer')?.open(), 100);
      } catch (error) {
        if (buyErrorWrapper && buyError) {
          buyError.textContent = error.message || 'Bitte versuchen Sie es erneut.';
          buyErrorWrapper.hidden = false;
        }
      } finally {
        buyButton.classList.remove('loading');
        buyButton.removeAttribute('aria-busy');
      }
    });
  };

  const initProductVideo = (video) => {
    if (video.dataset.obpVideoReady === 'true') return;
    video.dataset.obpVideoReady = 'true';

    const button = video.querySelector('[data-obp-video-play]');
    const videoId = video.dataset.videoId;
    if (!button || !videoId) return;

    button.addEventListener('click', () => {
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
      iframe.title = button.getAttribute('aria-label') || 'One Button Phone Produktvideo';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      video.replaceChildren(iframe);
    }, { once: true });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-obp-pdp-main]').forEach(initProductPage);
    scope.querySelectorAll('[data-obp-product-video]').forEach(initProductVideo);

    scope.querySelectorAll('[data-obp-scroll-buy]').forEach((button) => {
      if (button.dataset.obpScrollReady === 'true') return;
      button.dataset.obpScrollReady = 'true';
      button.addEventListener('click', () => {
        document.querySelector('[data-obp-offers]')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
